<template>
  <!-- 左侧树形菜单 author: zhangxiaofeng-->
  <div class="left-menu" :class="{'is-mask': showSubscribeMask, 'is-applications': nowModule === '/applications', 'hide-submenu-title': nowModule === '/applications' && !foldMenu, 'hide-menu-item': nowModule === '/applications' && foldMenu}">
    <div class="subscribe-mask" v-show="showSubscribeMask"></div>
    <w-scrollbar ref="scrollbar" wrap-style="overflow-x: hidden;" style="width: 100%;overflow-x: hidden;" :style="{height: contentHeight + 'px'}">
      <div :class="['left-menu--main', menuCanFold && foldMenu ? 'fold' : '']" :hash="hash">
        <w-menu :default-active="hash"
                :collapse="foldMenu"
                popupMenuBackground="#fff"
                subMenuBackground="transparent"
                backgroundColor="#f3f4f7"
                hoverBackground="#dddfe3"
                :border-right="false"
                @select="menuItemClick"
                @open="open"
                @close="close">
          <template v-for="(item, index) in leftMenus">
            <template v-if="item.children">
              <w-submenu :index="item.path" :key="index + item.id">
                <template slot="title">
                  <i v-if="item.icon" :class="[item.icon, marginLeftFold ? 'mg-l-22' : '']"></i>
                  <span slot="title" style="margin-left: 16px;">{{item.title}}</span>
                </template>
                <template v-for="(child, childIdx) in item.children">
                  <template v-if="child.children">
                    <w-submenu :index="child.path || child.linkUrl" :key="childIdx + child.id">
                      <i v-if="child.icon" :class="child.icon"></i>
                      <span slot="title" style="margin-left: 16px;">{{child.title}}</span>
                      <template v-for="(sub, subIdx) in child.children">
                        <w-menu-item :index="sub.path || sub.linkUrl" :key="subIdx + sub.id" :targetRoute="sub">
                          <i v-if="sub.icon" :class="sub.icon"></i>
                          <span slot="title" style="margin-left: 16px;">{{sub.title}}</span>
                        </w-menu-item>
                      </template>
                    </w-submenu>
                  </template>
                  <template v-else>
                    <w-menu-item :index="child.path || child.linkUrl" :key="childIdx + child.id" :targetRoute="child">
                      <i v-if="child.icon" :class="child.icon"></i>
                      <span slot="title" style="margin-left: 16px;">{{child.title}}</span>
                    </w-menu-item>
                  </template>
                </template>
              </w-submenu>
            </template>
            <template v-else>
              <w-menu-item :index="item.path || item.linkUrl" :key="index + item.id" :targetRoute="item">
                <i v-if="item.icon" :class="item.icon"></i>
                <span slot="title" style="margin-left: 16px;" :id="[item.routeName === '/project/database' ? 'recordProject' : '']">{{item.title}}</span>
              </w-menu-item>
            </template>
          </template>
        </w-menu>
        <!--<p class="fold-icon&#45;&#45;wrapper" v-if="menuCanFold">-->
        <!--<i :class="foldMenu ? 'r2-icon-nav_chevron_right' : 'r2-icon-nav_chevron_left'" @click.stop="foldMenuHandle"></i>-->
        <!--</p>-->
      </div>
    </w-scrollbar>
    <p class="fold-icon--wrapper" v-if="menuCanFold">
      <i :class="foldMenu ? 'r2-icon-nav_chevron_right' : 'r2-icon-nav_chevron_left'" @click.stop="foldMenuHandle"></i>
    </p>
  </div>
</template>
<style lang="less" type="text/less">
  .left-menu{
    height: 100%;
    background: #f3f4f7;
    overflow: hidden;
    position: relative;
    border-right: 1px solid rgba(33, 37, 48, .1);
    &.is-mask {
      border-right: 1px solid rgba(0, 0, 0, .5);
    }
    &.is-applications {
      .left-menu--main {
        padding-top: 0 !important;
        & > .w__menu {
          & > li {
            &:first-child {
              & > .w__submenu__title {
                pointer-events: none;
                user-select: none;
                height: 48px;
                background: #FFFFFF !important;
                border-bottom: 1px solid rgba(33, 37, 48, 0.1);
                i {
                  color: #ffffff;
                  display: inline-block;
                  width: 24px;
                  height: 24px;
                  border-radius: 50%;
                  text-align: center;
                  line-height: 24px;
                  font-size: 14px !important;
                  &.r2-icon-jisuan {
                    background: #29CBD1;
                  }
                  &.r2-icon-guize {
                    background: #2079FA;
                  }
                }
                .w__submenu__icon-arrow {
                  display: none;
                }
              }
            }
          }
        }
      }
    }

    .menu-title {
      height: 48px;
      padding: 12px 0 12px 22px;
      box-sizing: border-box;
      line-height: 24px;
      background: #FFFFFF;
      border-bottom: 1px solid rgba(33, 37, 48, 0.1);

      font-size: 16px;
      font-weight: 500;
      color: #212530;
      .menu-icon {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        text-align: center;
        line-height: 24px;
        i {
          font-size: 14px !important;
          color: #ffffff;
          vertical-align: baseline !important;
        }
        &.cyan  {
          background: #29CBD1;
        }

        &.blue {
          background: #2079FA;
        }

        &.green {
          background: #2CCC4A;
        }

        &.orange {
          background: #FF7C48;;
        }

        &.orange {
          background: #FF7C48;;
        }
      }
      .menu-text {
        padding-left: 8px;
      }
    }

    .fold-icon--wrapper{
      width: 12px;
      position: absolute;
      z-index: 2;
      height: 60px;
      line-height: 60px;
      right: 0;
      top: 50%;
      margin-top: -30px;
      margin-bottom: 0;
      text-align: center;
      background: #e0e1e5;
      border-radius: 8px 0 0 8px;
      i{
        font-size: 16px;
        color:rgba(33,37,48,0.55);
        cursor: pointer;
      }
    }
    &--main{
      width: 240px;
      height: 100%;
      box-sizing: border-box;
      padding-top: 8px;
      transition: all .3s cubic-bezier(.645, .045, .355, 1);
      &.fold{
        width: 64px;
        overflow: hidden;
      }
      .w__submenu__title i, .w__menu-item i{
        font-size: 20px;
      }
      .w-menu{
        color: #333;
        font-size: 14px;
        padding: 0;
        margin: 0;
        width: 240px;
        border-top: none;
        background: rgb(243,244,247);
        /* 右侧展开折点按钮 */
        .w-icon-sanjiao:before{
          font-family: "r2-iconfont";
          content: "\e8c2";
        }
      }
      .menu-red-point {
        height: 6px;
        width: 6px;
        border-radius: 6px;
        display: inline-block;
        text-align: center;
        font-size: 0.1em;
        color: #fff;
        background: red;
        position: relative;
        top: -10px;
      }
    }
  }
</style>
<script>
/* eslint-disable no-template-curly-in-string */
import { mapState, mapMutations } from 'vuex'
import { getCookie } from '@/assets/utils/CommonUtil'
import Bus from '@/assets/utils/bus'

export default {
  data () {
    return {
      timeString: new Date().getTime(),
      // foldMenu: false, // 是否折叠菜单
      marginLeftFold: false,
      menuCanFold: true
    }
  },
  props: {
    contentHeight: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState({
      routeNow: state => state.menus.routeNow,
      showSubscribeMask: state => state.showSubscribeMask,
      foldMenu: state => state.menus.foldMenu, // 是否折叠菜单
      nowModule: state => state.menus.nowModule, // 当前模块 (顶级菜单)
      leftMenus: state => state.menus.leftMenus.filter(item => (!item.linkUrl || (item.linkUrl && !item.linkUrl.includes('hideLeftMenus=true')))),
      activeMenuChain: state => state.menus.activeMenuChain,
      triggerMenuActiveChange: state => state.menus.triggerMenuActiveChange
    }),
    hash () {
      let activeMenu = ''
      if (this.$route.path.indexOf('/iframe/') !== -1) {
        activeMenu = decodeURIComponent(this.$route.query.linkUrl)
      } else {
        if (/^\/manage\/members/.test(this.$route.path)) {
          activeMenu = '/manage/members'
        } else {
          activeMenu = window.location.hash.slice(1)
        }
      }
      return activeMenu
    }
  },
  methods: {
    ...mapMutations({
      updateMenuStatus: 'menus/SET_MENUS_STATUS'
    }),
    open (data, index) {
      if (data === '/space/database') {
        this.sentLog(100113032)
      }
      this.menuRender(300)
    },
    close (data, index) {
      if (data === '/space/database') {
        this.sentLog(100113032)
      }
      this.menuRender(300)
    },
    // 1. 寻找当前树干是否是高亮菜单的父级、父级的父级...
    findFlag (item, index){
      let flag = false
      // activeMenuChain[1] && (child.path === activeMenuChain[1] || child.id === activeMenuChain[1])
      if (index >= 0 && this.activeMenuChain[index] !== undefined) {
        flag = item.path === this.activeMenuChain[index] || item.id === this.activeMenuChain[index]
      }
      const routePath = this.$route.path
      if (index === 1) {
        switch (routePath) {
          case '/upload/done/list':
          case '/upload/done/group':
            if (item.title === '数据上传记录' && item.children && item.children[0] && item.children[0].path === '/upload/done/list') {
              flag = true
            }
            break
          case '/upload/doing/list':
          case '/upload/doing/group':
            if (item.title === '数据上传记录' && item.children && item.children[0] && item.children[0].path === '/upload/doing/list') {
              flag = true
            }
            break
          default:
        }
      }
      return flag
    },
    menuItemClick (index, indexPath, item) {
      this.itemClick(item.$attrs.targetRoute)
    },
    // 2. 链接跳转
    itemClick (targetRoute, router) {
      this.setLoading({
        key: 'content',
        value: false
      })
      targetRoute.path = targetRoute.path ? targetRoute.path : encodeURIComponent(targetRoute.linkUrl)
      const ZJYUSERINFO = getCookie('ZJYUSERINFO')
      if (!ZJYUSERINFO) {
        // 登录超时
        this.setConfigState({ sessionAlertShow: true })
        return
      }
      // 点击当前左侧高亮菜单
      if (targetRoute.path === this.$route.path) return
      /* 埋点相关 start */
      switch (targetRoute.path) {
        case '/database/manage/configTask':
          this.sentLog(100115005)
          this.sentLog(100115006)
          break
        case '/database/manage/setPrivilege':
          this.sentLog(100115005)
          this.sentLog(100115010)
          break
        case '/space/files/list':
          this.sentLog(100113001)
          break
        case '/space/files/recycle':
          this.sentLog(100113002)
          break
        case '/enterprise/recycle':
          this.sentLog(100114011)
          break
        case '/enterprise/privilege':
          this.sentLog(100114001)
          break
        case '/enterprise/share':
          this.sentLog(100114002)
          break
        case '/project/joined':
        case '/project/joined/list':
          this.sentLog(100112002)
          break
        case '/project/all/list':
          this.sentLog(100112001)
          break
        case '/manage/members':
          this.sentLog(100117001)
          break
        case '/manage/asset':
          this.sentLog(100117089)
          break
        case '/manage/applications':
          this.sentLog(100111001)
          break
        case '/manage/records':
          this.sentLog(100107070)
          break
        default:
          if (targetRoute.menuName === '量价规则数据') {
            if (/^\/space/.test(window.topMenuPath)) {
              this.sentLog(100113051)
            } else {
              this.sentLog(100115042)
            }
          }
      }
      /* 埋点相关 end */
      switch (targetRoute.viewType) {
        // viewType为2显示为iframe
        case 2: {
          // let userType = +JSON.parse(ZJYUSERINFO).userType
          // const gldToken = getCookie('gldToken')
          // // const gldToken = 'cn-b3ea0db3-9304-4593-bc63-7beaafb9152f' // 价格库有权限的测试账号 2020/01/08 17:30
          // document.name = targetRoute.title
          // const linkUrl = targetRoute.linkUrl
          // let url = targetRoute.linkUrl.replace('${ZJYTOKEN}', getCookie('ZJYTOKEN'))
          //   .replace('${userType}', userType)
          //   .replace('${role}', this.role)
          //   .replace('${gldToken}', gldToken)
          // // 广材网 iframe 页面
          // // https://www.gldjc.com/doAutologin?access_token=${gldToken}&hostUrl=http%3A%2F%2Fqyzb.gldjc.com%2Fzjy%2FprojectReckon
          // // https://www.gldjc.com/doAutologin?access_token=cn-b4151f6e-bef4-407d-9787-be5abbb0aa36&hostUrl=http://qylib.gldjc.com/personalCollection/marketCollection?sys=FAVOR&from=GCW&consumer=ZJYXH
          // // 数据管理相关页面 先访问本地服务
          // // if (['清单数据', '定额数据', '人材机数据', '组价数据'].includes(targetRoute.title)) {
          // //   if (/^http:\/\/localhost-yy/.test(window.location.href)) {
          // //     url = url.replace('https://zjytest.glodon.com/bigdata', 'http://localhost-yy/bigdata')
          // //   } else if (/^http:\/\/localhost/.test(window.location.href)) {
          // //     url = url.replace('https://zjytest.glodon.com/bigdata', 'http://localhost:8083/bigdata')
          // //   }
          // // }
          // console.log('----------')
          // let path = `/iframe/${encodeURIComponent(url)}/${encodeURIComponent(targetRoute.title)}?t=${new Date().getTime()}&linkUrl=${encodeURIComponent(linkUrl)}`
          // const query = targetRoute.linkParameter.split(',') || []
          // if (query.length) {
          //   query.forEach((queryKey) => {
          //     switch (queryKey) {
          //       case 'zjytoken':
          //         path += '&zjytoken=' + getCookie('ZJYTOKEN')
          //         break
          //       default:
          //     }
          //   })
          // }
          // this.$router.push({path})
          this.openLinkNewTab(targetRoute, (url) => {
            let path = `/iframe/${encodeURIComponent(url)}/${encodeURIComponent(targetRoute.title)}?t=${new Date().getTime()}&linkUrl=${encodeURIComponent(targetRoute.linkUrl)}`
            // let path = `/iframe/${encodeURIComponent(url)}/${encodeURIComponent(targetRoute.title)}/${targetRoute.windowName}?t=${new Date().getTime()}&linkUrl=${encodeURIComponent(targetRoute.linkUrl)}`
            console.dir(path)
            this.$router.push({path})
          })
          break
        }
        default:
          this.$router.push({ path: targetRoute.path })
      }
    },
    // 3. 设置当前高亮菜单
    setActiveMenu () {
      const $route = this.$route
      let path = $route.path
      if ($route.params.linkUrl) {
        path = encodeURIComponent($route.params.linkUrl)
        document.name = decodeURIComponent($route.params.name)
      } else if (window.activeMenuId) {}
      // console.log(path)
      // console.log('1111111111111111111111-----------')
      let activeMenuChain = this.activeMenuChain
      if (activeMenuChain.length) {
        this.$refs.menu.selectIndex(activeMenuChain[activeMenuChain.length - 1])
      } else {
        this.$refs.menu.selectIndex(path)
      }
    },
    // 4. 展开折叠菜单
    foldMenuHandle () {
      this.menuRender(300, false)
      let timeSpace = 0
      if (!this.foldMenu) {
        timeSpace = 300
      }
      // this.foldMenu = !this.foldMenu
      this.updateMenuStatus(!this.foldMenu)
      const setMargin = (t, val) => {
        setTimeout(() => {
          this.marginLeftFold = val
          this.log()
        }, t)
      }
      setMargin(timeSpace, this.foldMenu)
    },
    // 菜单展开折叠 埋点
    log () {
      const ZJYUSERINFO = getCookie('ZJYUSERINFO')
      if (ZJYUSERINFO) {
        try {
          let type = +JSON.parse(ZJYUSERINFO).userType
          let status = this.marginLeftFold ? 2 : 1
          let page = 0
          switch (this.nowModule) {
            case '/space':
              if (type === 3) {
                page = 1 // 个人空间
              } else {
                page = 4 // 员工资料库
              }
              break
            case '/enterprise':
              page = 2 // 共享空间
              break
            case '/database':
              page = 3 // 电子档案室
              break
            case '/manage':
              page = 5 // 人员及资产管理
              break
            default:
          }
          if (type, status, page) {
            this.sentLog(100110036, {status, type, page})
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
    // 菜单渲染/更新
    menuRender (delay, show = true) {
      setTimeout(() => {
        Bus.$emit('leftMenuTips', show)
      }, delay)
    }
  },
  watch: {
    triggerMenuActiveChange (val) {
      // this.setActiveMenu()
    },
    leftMenus (menu) {
      // console.log('*********leftMenus***********', val)
      // this.foldMenu = true
      // this.marginLeftFold = true
      this.marginLeftFold = false
      // val.forEach(element => {
      //   if (element.menuName === '人员管理'){
      //     this.foldMenu = true
      //   }
      // })
      this.log()
      if (menu.length) {
        this.menuRender(100)
      }
    },
    contentHeight () {
      this.$refs.scrollbar.update()
    }
  },
  mounted () {
    this.log()
    this.$nextTick(() => {
      this.timeString = new Date().getTime()
      // this.setActiveMenu()
    })
    // debugger
  }
}
</script>
